<template>
  <div class="whd-login" style="background-image: url(/static/img/login/loginbg1.jpg)">
    <div class="whd-login__logo wow zoomInRight" data-wow-duration="1.2s"><img src="/static/img/login/text@2x.png" /></div>
    <div class="whd-login__aside wow fadeInDown" data-wow-delay="0.2s">
      <div class="weui-cell">
        <div class="weui-cell__bd">
          <div class="logosm"><img src="https://zaoxiang.oss-cn-hangzhou.aliyuncs.com/images/2024-02-27/b3fb768f35ac3438a6f27e1900ff378e.png" width="56" /></div>
          <h1>企业后台管理系统</h1>
          <h2>精准营销 行业标杆</h2>
          <div class="input-item weui-cell">
            <el-input placeholder="请输入帐号" v-model="form.username" autocomplete="new-password" />
          </div>
          <div class="input-item weui-cell">
            <el-input placeholder="请输入密码" v-model="form.password" :type="type" autocomplete="new-password" @focus="handleFocus" @blur="handleBlur" @keyup.enter.native="login" style="-webkit-text-security:disc;" />
          </div>
          <button type="submit" class="btn1" :loading="loading" @click="login">登录</button>
          <p class="f12">赋能全员的智能销售系统<br/>Copyright 2021 yunzhidata.cn All Rights Reserved<br/>闽ICP备13016694号</p>         
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import crypto from 'crypto'
  import { WOW } from 'wowjs'
  import api from '@/api.js'
  export default {
    name: "login",
    data() {
      return {
        loading:false,
        form: {
          username: "",
          password: ""
        },
        type: 'text'
      };
    },
    mounted() {
      var wow = new WOW({
        live: false
      })
      wow.init()
    },
    methods: {
      handleFocus() {
        this.type = 'password'
      },
      handleBlur() {
        this.type = 'text'
      },
      login() {
        if (!this.form.username) {
          this.$message({
            message: '请填写相应的账号',
            type: 'warning'
          });
          return false
        }
        if (!this.form.password) {
          this.$message({
            message: '请填写账号密码',
            type: 'warning'
          });
          return false
        }
        this.loading =true
        let md5 = crypto.createHash("md5")
        let passwordCode = this.form.password
        md5.update(passwordCode) // this.pw2这是你要加密的密码
        passwordCode = md5.digest('hex') //this.pw这就是你加密完的密码，这个往后台传就行了
        sessionStorage.removeItem('navMenu')
        this.axios
            .post(api.login, {username: this.form.username,password: passwordCode})
            .then(response => {
              if (response.data.code === 0) {
                sessionStorage.setItem('token', response.data.token)
                sessionStorage.setItem('keyid', response.data.appid)
                sessionStorage.setItem('navMenu', JSON.stringify(response.data.tree))
                this.$router.push({name: "workSpace"});
              }
              this.loading =false
            })
            .catch(response => {
            });
      }
    }
  };
</script>
